/** Shown in About Device and Software Update settings. */
export const DEVICE_SOFTWARE_VERSION = "1.2.18";
